(function () {
	angular
		.module('trackeye')
		.controller('ScheduleController', ScheduleController);

	ScheduleController.$inject = ["$state", "FlexEventService"];

	function ScheduleController($state, FlexEventService) {
		var vm = this;

		vm.eventData = {};
		vm.allDays = false;

		if ($state.params.eventData) {
			vm.eventData = $state.params.eventData;
		}

		vm.toggleAllDays = function () {
			var toggle = !vm.alldays,
				days = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];

			for (var i = 0; i < days.length; i++) {
				if (!vm.eventData.schedule[days[i]]) {
					vm.eventData.schedule[days[i]] = {
						active: toggle,
						from1: null,
						from2: null,
						to1: null,
						to2: null
					}
				}

				vm.eventData.schedule[days[i]].active = toggle;
			}

			vm.alldays = toggle;
		}

		vm.submit = function () {
			FlexEventService.saveSchedule(vm.eventData.schedule, vm.eventData.eventName);
			$state.go("^");
		};
	}
})();